<script setup>
import { onMounted, ref } from 'vue';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Referencia al contenedor del mapa
const mapContainer = ref(null);

onMounted(() => {
  // Inicializar el mapa
  const map = L.map(mapContainer.value).setView([26.517938, -81.760655], 13); // Coordenadas de Madrid como ejemplo

  // Añadir capa de OpenStreetMap
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; OpenStreetMap contributors',
    maxZoom: 19,
  }).addTo(map);

  // var greenIcon = L.icon({
  //   iconUrl: 'leaf-green.png',
  //   shadowUrl: 'leaf-shadow.png',
  //
  //   iconSize:     [38, 95], // size of the icon
  //   shadowSize:   [50, 64], // size of the shadow
  //   iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
  //   shadowAnchor: [4, 62],  // the same for the shadow
  //   popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
  // });

  // Añadir un marcador de ejemplo
  const marker = L.marker([26.517938, -81.760655]).addTo(map);
  marker.bindPopup('<b>GoTaxi</b><br>Florida.').openPopup();

  // Opcional: Añadir controles de zoom personalizados
  // L.control.zoom({
  //   position: 'topright',
  // }).addTo(map);
});
</script>

<template>
  <div class="h-full w-full flex flex-col items-center justify-center">
    <div ref="mapContainer" class="w-full h-96 md:h-[500px] lg:h-[600px] rounded shadow-lg"></div>
  </div>
</template>

<style scoped>
/* Asegúrate de que el contenedor del mapa ocupe el espacio deseado */
.map-container {
  height: 100%;
  width: 100%;
}
</style>
